/**
 * @generated SignedSource<<60f0feb3d0cd2033858155cc8655f4f7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionScoringCriteriaFragment$data = {
  readonly id: string;
  readonly slug: string;
  readonly stage: {
    readonly scoringCriteria: ReadonlyArray<{
      readonly description: string | null | undefined;
      readonly id: string;
      readonly title: string;
      readonly weight: number;
    }>;
    readonly seq: number;
    readonly viewerCanEdit: boolean;
  } | null | undefined;
  readonly " $fragmentType": "CompetitionScoringCriteriaFragment";
};
export type CompetitionScoringCriteriaFragment$key = {
  readonly " $data"?: CompetitionScoringCriteriaFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionScoringCriteriaFragment">;
};

import CompetitionScoringCriteriaFragmentQuery_graphql from './CompetitionScoringCriteriaFragmentQuery.graphql';

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "stage"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "node"
      ],
      "operation": CompetitionScoringCriteriaFragmentQuery_graphql,
      "identifierInfo": {
        "identifierField": "id",
        "identifierQueryVariableName": "id"
      }
    }
  },
  "name": "CompetitionScoringCriteriaFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "stage",
          "variableName": "stage"
        }
      ],
      "concreteType": "CompetitionStage",
      "kind": "LinkedField",
      "name": "stage",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "seq",
          "storageKey": null
        },
        {
          "alias": "viewerCanEdit",
          "args": [
            {
              "kind": "Literal",
              "name": "action",
              "value": "UPDATE_COMPETITION_STAGE"
            }
          ],
          "kind": "ScalarField",
          "name": "viewerCan",
          "storageKey": "viewerCan(action:\"UPDATE_COMPETITION_STAGE\")"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "CompetitionScoringCriterion",
          "kind": "LinkedField",
          "name": "scoringCriteria",
          "plural": true,
          "selections": [
            (v0/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "title",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "description",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "weight",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v0/*:: as any*/)
  ],
  "type": "Competition",
  "abstractKey": null
};
})();

(node as any).hash = "2cb98affb4d5585391b4dd472b691d91";

export default node;
